var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.widthStyle })},[_vm._t("default",null,{"label":_vm.label,"rules":_vm.parsedRules})],2)}
var staticRenderFns = []

export { render, staticRenderFns }